import { TaxInfo } from './_Shared.js';

window.onload = function TaxInfoStart () {
    TaxInfo.Input.Init();

    $("#swiper").change(function () {
        var swiperValue = $(this).val();
        if (swiperValue > 4800) {
            $("#btnSubmitInput").removeAttr("disabled");
        }
        else {
            $("#btnSubmitInput").attr("disabled", "disabled");
        }
    });

    displayVisibility();

    $("#ShowAdditionalFields").click(function () {
        displayVisibility();
    });

    function displayVisibility() {

        if ($("#ShowAdditionalFields").prop("checked")) {
            $(".additionalField").show();
        }
        else {
            $(".additionalField").hide();
        }
    };
};